import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AccessRightAdmin,
  AccessRightMaintenance,
  AuthGuard,
  BlockPageAuthGuard,
  CanAuthenticationGuard,
} from './utils/authguard';

const appRoutes: Routes = [
  {
    path: 'logs',
    canActivate: [CanAuthenticationGuard, AccessRightAdmin, BlockPageAuthGuard],
    loadComponent: () =>
      import('./main/log-list/log-list.component').then(
        mod => mod.LogListComponent
      ),
  },
  {
    path: 'upi',
    canActivate: [CanAuthenticationGuard, AuthGuard, AccessRightAdmin],
    loadChildren: () => import('./main/upi/upi.module').then(m => m.UpiModule),
  },
  {
    path: 'users-external',
    canActivate: [
      CanAuthenticationGuard,
      AuthGuard,
      AccessRightMaintenance,
      BlockPageAuthGuard,
    ],
    loadComponent: () =>
      import(
        './main/user-management/users-external/users-external.component'
      ).then(mod => mod.UsersExternalComponent),
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
